<template>
  <div class="flex xl12 lg12 md12 mx-auto">
    <vue-pull-refresh :on-refresh="onRefresh" :config="pullConfig">
      <v-card color="transparent">
        <v-card-title>
          <v-layout wrap>
            <v-flex xs12 sm8 text-xs-left></v-flex>
            <v-flex xs12 sm4 text-xs-right>
              <v-text-field
                append-icon="search"
                label="Zoeken"
                single-line
                hide-details
                v-model="search"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-data-table
          v-model="selected"
          v-bind:headers="headers"
          v-bind:items="items"
          v-bind:pagination.sync="pagination"
          :rows-per-page-items="[25,50]"
          item-key="name"
        >
          <template slot="headers" slot-scope="props">
            <tr class="hidden-xs-only">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable text-xs-left', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                {{ header.text }}
                <v-icon>arrow_upward</v-icon>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <td class="hidden-xs-only">{{ props.item.id }}</td>
              <td class="text-xs-left hidden-xs-only">{{ props.item.unitDescription }}</td>
              <td class="text-xs-left hidden-xs-only">{{ props.item.testDriveDescription }}</td>
              <td class="text-xs-left hidden-xs-only">{{ props.item.startDate }}</td>
              <td class="text-xs-left hidden-xs-only">{{ props.item.endDate }}</td>
              <td class="text-xs-left hidden-sm-and-up itemRow">
                <h3>#{{ props.item.id }} {{ props.item.unitDescription }}</h3>
                {{props.item.testDriveDescription}}
                <br>
                {{ props.item.startDate }}
                <br>
                {{ props.item.endDate }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </vue-pull-refresh>
  </div>
</template>
<script>
import * as utils from "@/utils/utils";
import VuePullRefresh from "vue-pull-refresh";
export default {
  name: "TestDrivesHistoryTable",
  components: { VuePullRefresh },
  props: ["ts"],
  data() {
    return {
      pullConfig: window.pullConfig,
      dialog: false,
      pagination: {
        sortBy: "id",
        descending: true
      },
      selected: [],
      search: "",
      headers: [
        {
          text: "#",
          align: "left",
          value: "id"
        },
        { text: "Unit", value: "unitDescription" },
        { text: "Omschrijving", value: "testdriveDescription" },
        { text: "Starttijd", value: "startDate" },
        { text: "Eindtijd", value: "endDate" }
      ],
      items: [],
      allItems: []
    };
  },
  watch: {
    ts(newVal) {
      if (newVal) {
        this.getHistory();
      }
    },
    search(val) {
      let self = this;
      let searchText = val.toLowerCase();
      let searchableItems = this.allItems;
      var options = {
        keys: [
          "unitDescription",
          "testDriveDescription",
          "startDate",
          "endDate"
        ]
      };
      if (val == "") {
        this.items = searchableItems;
      } else {
        this.$search(searchText, searchableItems, options).then(results => {
          self.items = results;
        });
      }
    }
  },
  created: function() {},
  methods: {
    getHistory() {
      var self = this;
      return utils
        .getData(basePath + "api/TestDrives/testDriveHistory/")
        .then(function(json) {
          if (json && json.data) {
            self.allItems = json.data;
            self.items = self.allItems;
          }
        });
    },
    showUser(user) {
      user.edit = true;
      this.$emit("showUser", user);
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.items.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    onRefresh() {
      const self = this;
      return new Promise(function(resolve, reject) {
        self.getHistory(false).then(function() {
          setTimeout(function() {
            resolve();
          }, 500);
        });
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/TestDrives/TestDrivesHistoryTable.vue